(function() {
  'use strict';

const CONFIG = {
    cities: [
      'Abbottabad', 'Ahmedpur East', 'Ahmedpur Sial', 'Akora Khattak', 'Ali Pur', 
      'Arifwala', 'Attock', 'Badin', 'Bagh', 'Bahawalnagar', 'Bahawalpur', 'Bannu', 
      'Barkhan', 'Batkhela', 'Battagram', 'Bhakkar', 'Bhalwal', 'Bhimber', 'Burewala', 
      'Chaghi', 'Chaman', 'Charsadda', 'Chichawatni', 'Chiniot', 'Chishtian', 'Chitral', 
      'Chunian', 'Dadu', 'Daska', 'Dera Allah Yar', 'Dera Bugti', 'Dera Ghazi Khan', 
      'Dera Ismail Khan', 'Dina', 'Dinga', 'Diplo', 'Faisalabad', 'Fateh Jang', 
      'Gakhar Mandi', 'Ghotki', 'Gilgit', 'Gojra', 'Gujar Khan', 'Gujranwala', 'Gujrat', 
      'Hafizabad', 'Hangu', 'Haripur', 'Hasilpur', 'Hassan Abdal', 'Hub', 'Hunza', 
      'Hyderabad', 'Islamabad', 'Jacobabad', 'Jalalpur Jattan', 'Jalalpur Pirwala', 
      'Jampur', 'Jaranwala', 'Jatoi', 'Jauharabad', 'Jhang', 'Jhelum', 'Kabal', 
      'Kahror Pakka', 'Kalat', 'Kamalia', 'Kamoke', 'Kandhkot', 'Karachi', 'Kasur', 
      'Khairpur', 'Khanewal', 'Khanpur', 'Kharian', 'Khushab', 'Khuzdar', 'Kohat', 
      'Kot Addu', 'Kotli', 'Lahore', 'Lakki Marwat', 'Lalamusa', 'Larkana', 'Lasbela', 
      'Layyah', 'Liaquatpur', 'Lodhran', 'Mailsi', 'Malakand', 'Mansehra', 'Mardan', 
      'Matiari', 'Mian Channu', 'Mianwali', 'Mingora', 'Mirpur (AJK)', 'Mirpur Khas', 
      'Mithi', 'Moro', 'Multan', 'Muridke', 'Murree', 'Muzaffarabad', 'Muzaffargarh', 
      'Nankana Sahib', 'Narowal', 'Nasirabad', 'Naushahro Feroze', 'Nawabshah', 'Okara', 
      'Pakpattan', 'Panjgur', 'Pano Aqil', 'Pasni', 'Pattoki', 'Peshawar', 'Phalia', 
      'Pir Mahal', 'Quetta', 'Rahim Yar Khan', 'Rajanpur', 'Rawalakot', 'Rawalpindi', 
      'Sadiqabad', 'Sahiwal', 'Sambrial', 'Samundri', 'Sanghar', 'Sargodha', 'Shahdadkot', 
      'Shahdadpur', 'Shahkot', 'Shakargarh', 'Sheikhupura', 'Shikarpur', 'Sialkot', 
      'Sibi', 'Skardu', 'Sohawa', 'Sukkur', 'Swabi', 'Swat', 'Tando Adam', 
      'Tando Allahyar', 'Tando Muhammad Khan', 'Tank', 'Taxila', 'Thatta', 'Timergara', 
      'Toba Tek Singh', 'Turbat', 'Uch Sharif', 'Umerkot', 'Vehari'
    ],
    restrictedTag: 'quetta-only',
    storageKey: 'selected_city',
    popupId: 'city-selector-popup',
    cookieExpiry: 365,
    showPopupOnAddToCart: true,
    deliveryTiming: {
      'Quetta': '30-40 min',
      'Karachi': '2-3 days',
      'Lahore': '2-3 days',
      'Islamabad': '2-3 days',
      'default': '2-3 days'
    }
  };

  const Utils = {
    getSelectedCity: function() {
      return localStorage.getItem(CONFIG.storageKey) || null;
    },

    setSelectedCity: function(city) {
      localStorage.setItem(CONFIG.storageKey, city);
      this.setCookie(CONFIG.storageKey, city, CONFIG.cookieExpiry);
    },

    setCookie: function(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      const expires = "expires=" + date.toUTCString();
      document.cookie = name + "=" + value + ";" + expires + ";path=/";
    },

    hasTag: function(tags, tagToCheck) {
      if (!tags) return false;
      const tagsArray = Array.isArray(tags) ? tags : tags.split(',').map(t => t.trim().toLowerCase());
      return tagsArray.includes(tagToCheck.toLowerCase());
    },

    dispatchEvent: function(eventName, detail) {
      const event = new CustomEvent(eventName, { detail: detail });
      document.dispatchEvent(event);
    }
  };

  const PopupManager = {
    isOpen: false,
    filteredCities: CONFIG.cities,
    pendingAddToCart: null,

    show: function(isMandatory = false, onSelectCallback = null) {
      if (typeof onSelectCallback !== 'function') {
        this.pendingAddToCart = null;
      }
      if (this.isOpen) return;
      
      this.isOpen = true;
      this.filteredCities = CONFIG.cities;
      this.pendingAddToCart = typeof onSelectCallback === 'function' ? onSelectCallback : null;
      
      const popup = this.createPopup(isMandatory);
      document.body.appendChild(popup);
      
      setTimeout(() => {
        popup.classList.add('active');
        const searchInput = document.getElementById('citySearchInput');
        if (searchInput) searchInput.focus();
      }, 10);

      if (isMandatory) {
        document.body.style.overflow = 'hidden';
      }

      this.attachSearchEvent();
    },

    showManual: function() {
      this.pendingAddToCart = null;
      this.show(false, null);
    },

    hide: function() {
      const popup = document.getElementById(CONFIG.popupId);
      if (!popup) return;

      popup.classList.remove('active');
      setTimeout(() => {
        popup.remove();
        this.isOpen = false;
        this.pendingAddToCart = null;
        document.body.style.overflow = '';
      }, 300);
    },

    createPopup: function(isMandatory) {
      const popup = document.createElement('div');
      popup.id = CONFIG.popupId;
      popup.className = 'city-selector-popup';
      popup.setAttribute('role', 'dialog');
      popup.setAttribute('aria-modal', 'true');

      const currentCity = Utils.getSelectedCity();

      popup.innerHTML = `
        <div class="city-popup-overlay" ${!isMandatory ? 'onclick="PopupManager.hide()"' : ''}></div>
        <div class="city-popup-content">
          <div class="city-popup-header">
            <h2>Select your delivery location</h2>
          </div>
          <div class="city-popup-body">
            <p class="city-popup-label">Choose your city to see available products and delivery options</p>
            
            <div class="city-search-wrapper">
              <input 
                type="text" 
                id="citySearchInput" 
                class="city-search-input" 
                placeholder="Search city..."
                autocomplete="off"
              />
              <svg class="search-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="11" cy="11" r="8"></circle>
                <path d="m21 21-4.35-4.35"></path>
              </svg>
            </div>
            
            <div class="city-dropdown-wrapper">
              <select class="city-dropdown" id="cityDropdown">
                <option value="">Select a city</option>
                ${this.filteredCities.map(city => `
                  <option value="${city}" ${currentCity === city ? 'selected' : ''}>${city}</option>
                `).join('')}
              </select>
            </div>
            
            <button type="button" class="city-select-btn" onclick="PopupManager.confirmSelection()">Select</button>
          </div>
        </div>
      `;

      return popup;
    },

    attachSearchEvent: function() {
      const searchInput = document.getElementById('citySearchInput');
      const dropdown = document.getElementById('cityDropdown');
      
      if (!searchInput || !dropdown) return;

      searchInput.addEventListener('input', (e) => {
        const searchTerm = e.target.value.toLowerCase();
        
        this.filteredCities = CONFIG.cities.filter(city => 
          city.toLowerCase().includes(searchTerm)
        );

        const currentCity = Utils.getSelectedCity();
        dropdown.innerHTML = `
          <option value="">Select a city</option>
          ${this.filteredCities.map(city => `
            <option value="${city}" ${currentCity === city ? 'selected' : ''}>${city}</option>
          `).join('')}
        `;

        if (this.filteredCities.length === 1) {
          dropdown.value = this.filteredCities[0];
        }
      });

      searchInput.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          if (this.filteredCities.length === 1) {
            dropdown.value = this.filteredCities[0];
          }
          this.confirmSelection();
        }
      });
    },

    confirmSelection: function() {
      const dropdown = document.getElementById('cityDropdown');
      const selectedCity = dropdown.value;

      if (!selectedCity) {
        alert('Please select a city');
        return;
      }

      const pendingCallback = typeof this.pendingAddToCart === 'function'
        ? this.pendingAddToCart
        : null;
      this.pendingAddToCart = null;

      Utils.setSelectedCity(selectedCity);
      this.hide();
      
      HeaderManager.update();
      
      Utils.dispatchEvent('cityChanged', { city: selectedCity });
      this.showToast(`Delivery location set to ${selectedCity}`);

      if (pendingCallback) {
        setTimeout(() => {
          pendingCallback();
        }, 350);
      }
    },

    showToast: function(message) {
      const toast = document.createElement('div');
      toast.className = 'city-toast';
      toast.textContent = message;
      document.body.appendChild(toast);

      setTimeout(() => toast.classList.add('show'), 10);
      setTimeout(() => {
        toast.classList.remove('show');
        setTimeout(() => toast.remove(), 300);
      }, 3000);
    }
  };

  window.PopupManager = PopupManager;

  const HeaderManager = {
    init: function() {
      this.createDesktopSelector();
      this.createMobileSelector();
      this.update();
    },

    createDesktopSelector: function() {
      const header = document.querySelector('header');
      if (!header || document.getElementById('desktop-city-selector')) return;

      const selector = document.createElement('div');
      selector.id = 'desktop-city-selector';
      selector.className = 'desktop-city-selector';
      selector.innerHTML = `
        <button type="button" class="desktop-city-btn" onclick="PopupManager.showManual()" aria-label="Change delivery location">
          <svg class="uk-location-pin" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M20 10c0 5.5-8 11-8 11S4 15.5 4 10a8 8 0 1 1 16 0Z"></path>
            <circle cx="12" cy="10" r="2.6"></circle>
          </svg>
          <span class="desktop-city-text">
            <span class="desktop-city-label">Deliver to</span>
            <span class="desktop-city-name">Select</span>
          </span>
        </button>
      `;

      const customSlot = header.querySelector('[data-uk-city-desktop]');
      if (customSlot) {
        customSlot.appendChild(selector);
        return;
      }

      const logo = header.querySelector('.header__heading-link, .header__heading, [class*="logo"]');
      if (logo && logo.parentNode) {
        logo.parentNode.insertBefore(selector, logo.nextSibling);
      } else {
        const headerInner = header.querySelector('.header__inline-menu, header > div');
        if (headerInner) {
          headerInner.insertBefore(selector, headerInner.firstChild);
        }
      }
    },

    createMobileSelector: function() {
      const header = document.querySelector('header');
      if (!header || document.getElementById('mobile-city-icon')) return;

      const mobileIcon = document.createElement('div');
      mobileIcon.id = 'mobile-city-icon';
      mobileIcon.className = 'mobile-city-icon';
      mobileIcon.innerHTML = `
        <button type="button" class="mobile-city-icon-btn" onclick="PopupManager.showManual()" aria-label="Change delivery location">
          <svg class="uk-location-pin" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M20 10c0 5.5-8 11-8 11S4 15.5 4 10a8 8 0 1 1 16 0Z"></path>
            <circle cx="12" cy="10" r="2.6"></circle>
          </svg>
          <span class="mobile-city-text">
            <span class="mobile-city-kicker">Deliver to</span>
            <span class="mobile-city-label">Select city</span>
          </span>
        </button>
      `;

      const customSlot = header.querySelector('[data-uk-city-mobile]');
      if (customSlot) {
        customSlot.appendChild(mobileIcon);
        return;
      }

      const cartIcon = header.querySelector('.header__icons a[href*="cart"], [href="/cart"], .cart-link');
      if (cartIcon) {
        cartIcon.parentNode.insertBefore(mobileIcon, cartIcon);
      }
    },

    update: function() {
      const selectedCity = Utils.getSelectedCity();
      
      const desktopName = document.querySelector('.desktop-city-name');
      if (desktopName) {
        desktopName.textContent = selectedCity || 'Select';
      }
      
      const mobileLabel = document.querySelector('.mobile-city-label');
      if (mobileLabel) {
        mobileLabel.textContent = selectedCity || 'Select city';
      }

      document.querySelectorAll('[data-uk-location-city]').forEach((element) => {
        element.textContent = selectedCity || 'Select city';
      });
    }
  };

  window.UKHCityDelivery = {
    config: CONFIG,
    utils: Utils,
    popup: PopupManager,
    header: HeaderManager
  };

  function initCore() {
    HeaderManager.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCore, { once: true });
  } else {
    initCore();
  }
})();
